'use client';

import { useSessionMonitor } from '~/components/hooks/useSessionMonitor';

interface Props {
    checkInterval?: number;
}

export const SessionMonitor = (props: Props) => {
    useSessionMonitor({
        checkInterval: props.checkInterval,
    });

    return null;
};
